<template>
  <div class="section pt-5">
    <timebag-datatable ref="timebag_datatable"></timebag-datatable>
  </div>
</template>

<script>
import { get, error_message } from "@/utils";
import TimebagDatatable from "./timebag_datatable/Index.vue";

export default {
  name: "Timebag",
  components: { TimebagDatatable },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
